/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setReportProperties } from 'state/actions/reportsState/selected_report_status';
// component
import Filters from 'pages/dashboard/reports/detail/filters/filters';



/* ========== ~~~~~~~~~~ REPORT FILTERS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ accountData, reportsState }) => ({
    allCountries: reportsState.reportsStatus.allCountries,
    allSites: accountData.sites,
    sitesReceived: accountData.sitesReceived,
    allDevices: reportsState.reportsStatus.allDevices,
    sites: reportsState.selectedReportStatus.selectedReportData.sites,
    devices: reportsState.selectedReportStatus.selectedReportData.devices,
    countries: reportsState.selectedReportStatus.selectedReportData.countries,
    mode: reportsState.reportsStatus.mode
});

// map actions
const mapDispatchToProps = dispatch => ({
    setReportProperties: data => dispatch(setReportProperties(data))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Filters);
